(function () {
  // Mobile menu
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.getElementById('MobileNav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Product gallery: thumbnails + tap/click to zoom
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    var mainImg = main && main.querySelector('img');
    gallery.querySelectorAll('[data-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        mainImg.src = btn.getAttribute('data-src');
        mainImg.srcset = '';
        mainImg.alt = btn.getAttribute('data-alt') || '';
        main.classList.remove('is-zoomed');
        gallery.querySelectorAll('[data-thumb]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
        btn.setAttribute('aria-current', 'true');
      });
    });
    if (main) {
      main.addEventListener('click', function () { main.classList.toggle('is-zoomed'); });
      main.addEventListener('mousemove', function (e) {
        if (!main.classList.contains('is-zoomed')) return;
        var r = main.getBoundingClientRect();
        mainImg.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      });
    }
  });

  // Quantity selectors
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('[data-qty-change]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        v = Math.max(parseInt(input.min || '1', 10), v + parseInt(btn.getAttribute('data-qty-change'), 10));
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  // Variant selector keeps the hidden id + price in sync
  document.querySelectorAll('[data-variant-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var opt = sel.options[sel.selectedIndex];
      var form = sel.closest('form');
      var price = document.querySelector('[data-product-price]');
      if (price && opt.getAttribute('data-price')) price.textContent = opt.getAttribute('data-price');
      var btn = form && form.querySelector('[type="submit"]');
      if (btn) {
        var available = opt.getAttribute('data-available') === 'true';
        btn.disabled = !available;
        btn.textContent = available ? btn.getAttribute('data-label-add') : btn.getAttribute('data-label-sold');
      }
    });
  });
})();
